import { builder, Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { BUILDER_PUBLIC_API_KEY } from './constants/common';

builder.init(BUILDER_PUBLIC_API_KEY);

Builder.registerComponent(
  dynamic(() => import('./pages/SellCar/containers/SellCarRequestFormWrapperContainer')),
  {
    name: 'Sell Car Request Form',
  },
);

Builder.registerComponent(
  dynamic(() => import('./pages/Home/components/BuyHunt/BuyHuntContainer')),
  {
    name: 'Buy Hunt Form',
  },
);

Builder.registerComponent(
  dynamic(() => import('./components/Builder/CCPOBanner')),
  {
    name: 'CCPO Banner',
  },
);

Builder.registerComponent(
  dynamic(() => import('./components/Builder/FeaturedCars')),
  {
    name: 'Featured Cars',
    inputs: [
      {
        name: 'title',
        friendlyName: 'Title',
        defaultValue: 'Featured Cars',
        type: 'text',
      },
      {
        name: 'sourceUrl',
        friendlyName: 'Source URL',
        type: 'text',
        required: false,
        helperText:
          'Display cars from a source URL. (e.g: https://staging-crazy-rabbit.getcarsstaging.com/sg/en/buy/honda/vezel)',
      },
      {
        name: 'limit',
        friendlyName: 'Number of cars to display from the source URL',
        type: 'number',
        required: false,
        defaultValue: 6,
        helperText: '(Maximum 48)',
      },
      {
        name: 'listingIds',
        friendlyName: 'Listing IDs (maximum 48)',
        type: 'text',
        required: false,
        helperText: 'comma separated, e.g: 216279,216200,218106',
      },
    ],
  },
);
